import { ACCOUNT } from '@/constants/links'
import { AccountPage } from '@/pages/account/_dashboard/page'
import type { CustomRouteObject, FortemRouteHandle } from '@/router'

export const accountRoutes = [
  {
    path: '/account',
    children: [
      {
        index: true,
        element: <AccountPage />,
        handle: {
          title: ACCOUNT.DASHBOARD.label,
        },
      },
    ],
  },
] satisfies CustomRouteObject<FortemRouteHandle>[]
